module.exports = __webpack_public_path__ + "static/media/sampleReport6.be34d033.png";